import type { CategoriesApi } from '@/v2/api/metadata/categories'
import type { SportsApi } from '@/v2/api/metadata/sports'
import { FilterType, type Filter } from '@/v2/framework/filter/types'
import type { BackofficeContext } from '@/v2/framework/context/types'

import { tournamentGamesStatusOptions, tournamentStatusOptions } from '../shared'

function mapEntityOptions(records: Record<string, unknown>[]) {
  return records.map((item) => ({
    value: item.id,
    title: String(item.computedName ?? item.name ?? ''),
  }))
}

export function createFilters(options: {
  ctx: BackofficeContext
  sportsApi: SportsApi
  categoriesApi: CategoriesApi
}): Filter[] {
  const { ctx, sportsApi, categoriesApi } = options

  return [
    {
      key: 'status',
      label: 'common.labels.status',
      placeholder: 'common.labels.status',
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: tournamentStatusOptions,
      multiple: true,
    },
    {
      key: 'liveGameStatus',
      label: 'common.labels.live_status',
      placeholder: 'common.labels.live_status',
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: tournamentGamesStatusOptions,
      multiple: true,
    },
    {
      key: 'prematchGameStatus',
      label: 'common.labels.prematch_status',
      placeholder: 'common.labels.prematch_status',
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: tournamentGamesStatusOptions,
      multiple: true,
    },
    {
      key: 'language',
      label: 'common.labels.language',
      placeholder: 'common.labels.language',
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: async () =>
        ctx.read.languages().map((language) => ({
          value: language.code,
          title: `languages.${language.code}`,
        })),
      multiple: false,
      searchable: true,
    },
    {
      key: 'sportId',
      label: 'common.labels.sport',
      placeholder: 'common.labels.sport',
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: async () => mapEntityOptions(await sportsApi.getFilters({ page: 1, size: -1 })),
      searchable: true,
      multiple: true,
    },
    {
      key: 'categoryId',
      label: 'common.labels.category',
      placeholder: 'common.labels.category',
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: async () => mapEntityOptions(await categoriesApi.getFilters({ page: 1, size: 100 })),
      searchable: true,
      multiple: true,
    },
  ]
}
